import { isEqual } from 'lodash';

function isVariableValueEqual(a, b) {
  if (a === b) {
    return true;
  }
  return isEqual(a, b);
}
function safeStringifyValue(value) {
  try {
    return JSON.stringify(value, null);
  } catch (error) {
    console.error(error);
  }
  return "";
}

export { isVariableValueEqual, safeStringifyValue };
//# sourceMappingURL=utils.js.map
